import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Inline mini lead-capture: short form to capture name + phone for a callback
export default function MiniLeadForm({ context = "general", title, sub }) {
  const [data, setData] = useState({ name: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.phone || !data.email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/clarity-call/book`, {
        looking_for: context === "holiday" ? "holiday_home" : context === "plot" ? "plot" : "not_sure",
        desired_outcome: "rental_income",
        budget_min: 7500000,
        budget_max: 15000000,
        loan_required: "maybe",
        timeline: "exploring",
        name: data.name,
        email: data.email,
        phone: data.phone,
        notes: `Quick callback request from ${context} section`,
      });
      setDone(true);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="bg-[#0A0A0A] text-white rounded-3xl p-8 md:p-10" data-testid={`mini-lead-success-${context}`}>
        <div className="font-display text-2xl">Thanks {data.name.split(" ")[0]} — we'll call you within 24 hours.</div>
        <p className="text-zinc-300 mt-2">In the meantime, want to read more or book a full Clarity Call?</p>
        <Link to="/clarity-call" className="inline-flex items-center gap-2 bg-white text-zinc-900 px-5 py-2.5 rounded-full font-medium mt-5 text-sm">
          Book Clarity Call <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-white border-2 border-[#1D4ED8] rounded-3xl p-8 md:p-10" data-testid={`mini-lead-${context}`}>
      <div className="text-xs uppercase tracking-widest text-[#1D4ED8] flex items-center gap-2">
        <Mail className="h-4 w-4" /> Free callback
      </div>
      <h3 className="font-display text-3xl mt-3 leading-snug">{title}</h3>
      <p className="text-zinc-600 mt-3">{sub}</p>
      <form onSubmit={submit} className="mt-6 grid md:grid-cols-3 gap-3">
        <input
          required
          value={data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
          placeholder="Your name"
          className="px-4 py-3 rounded-full border border-zinc-200 focus:outline-none focus:border-[#1D4ED8]"
          data-testid={`mini-name-${context}`}
        />
        <input
          required
          value={data.email}
          onChange={(e) => setData({ ...data, email: e.target.value })}
          type="email"
          placeholder="Email"
          className="px-4 py-3 rounded-full border border-zinc-200 focus:outline-none focus:border-[#1D4ED8]"
          data-testid={`mini-email-${context}`}
        />
        <input
          required
          value={data.phone}
          onChange={(e) => setData({ ...data, phone: e.target.value })}
          placeholder="Phone (+91...)"
          className="px-4 py-3 rounded-full border border-zinc-200 focus:outline-none focus:border-[#1D4ED8]"
          data-testid={`mini-phone-${context}`}
        />
        <div className="md:col-span-3 flex flex-wrap items-center gap-3">
          <button type="submit" disabled={loading} className="btn-primary disabled:opacity-50" data-testid={`mini-submit-${context}`}>
            {loading ? "Submitting..." : "Request a callback"} <ArrowRight className="h-4 w-4" />
          </button>
          <span className="text-xs text-zinc-500">No spam. No broker calls. Ever.</span>
        </div>
      </form>
    </div>
  );
}
